import axios from "axios"
import { customToast } from "../components/toast/custom-react-toastify/v1"

const MAIN_API_HOST = process.env.REACT_APP_MAIN_API_HOST

export function AnalyticsApi(props) {
    return {
        stockCycle: async ({ params, headers, body }) => {
            return await axios.get(`${MAIN_API_HOST}/analytics/stock-cycle/iqr`, {
                params: {
                    ...params,
                    productCategoryIds: params?.productCategoryIds,
                    dailyDetailYn: 'y'
                },
                headers
            })
                .then(res => {
                    if (res.status === 200) {
                        return {
                            res: res,
                            content: res.data?.content
                        }
                    }
                })
                .catch(err => {
                    if (!err) {
                        customToast.error('서버와의 연결이 원할하지 않습니다.');
                        return;
                    }

                    let res = err.response;

                    customToast.error(res?.data?.message);
                })
        },
        stockCycleV3: async ({ params, headers, body }) => {
            return await axios.get(`${MAIN_API_HOST}/analytics/stock-cycle/iqr/v3`, {
                params: {
                    ...params,
                    productCategoryIds: params?.productCategoryIds,
                    dailyDetailYn: 'y',
                    orderQtyMultiplier: params?.orderQtyMultiplier,
                    highQuantileMultiplier: params?.highQuantileMultiplier,
                    dailyRateMultiplier: params?.dailyRateMultiplier
                },
                headers
            })
                .then(res => {
                    if (res.status === 200) {
                        return {
                            res: res,
                            content: res.data?.content
                        }
                    }
                })
                .catch(err => {
                    if (!err) {
                        customToast.error('서버와의 연결이 원할하지 않습니다.');
                        return;
                    }

                    let res = err.response;

                    customToast.error(res?.data?.message);
                })
        },
        searchStockCycleMemo: async ({ params, headers, body }) => {
            return await axios.get(`${MAIN_API_HOST}/analytics/stock-cycle/memo`, {
                params,
                headers
            })
                .then(res => {
                    if (res.status === 200) {
                        return {
                            res: res,
                            content: res.data?.content
                        }
                    }
                })
                .catch(err => {
                    if (!err) {
                        customToast.error('서버와의 연결이 원할하지 않습니다.');
                        return;
                    }

                    let res = err.response;

                    customToast.error(res?.data?.message);
                })
        },
        searchOrders: async ({ params, headers, body }) => {
            return await axios.get(`${MAIN_API_HOST}/analytics/stock-cycle/search-orders`, {
                params,
                headers
            })
                .then(res => {
                    if (res.status === 200) {
                        return {
                            res: res,
                            content: res.data?.content
                        }
                    }
                })
                .catch(err => {
                    if (!err) {
                        customToast.error('서버와의 연결이 원할하지 않습니다.');
                        return;
                    }

                    let res = err.response;

                    customToast.error(res?.data?.message);
                })
        },
        searchOrderUnitListForSales: async ({ params, headers, body }) => {
            return await axios.get(`${MAIN_API_HOST}/analytics/stock-cycle/order-unit-list-for-sales`, {
                params,
                headers
            })
                .then(res => {
                    if (res.status === 200) {
                        return {
                            res: res,
                            content: res.data?.content
                        }
                    }
                })
                .catch(err => {
                    if (!err) {
                        customToast.error('서버와의 연결이 원할하지 않습니다.');
                        return;
                    }

                    let res = err.response;

                    customToast.error(res?.data?.message);
                })
        },
        createStockCycleMemo: async ({ params, headers, body }) => {
            return await axios.post(`${MAIN_API_HOST}/analytics/stock-cycle/memo`, body, {
                headers
            })
                .then(res => {
                    if (res.status === 200) {
                        return {
                            res: res,
                            content: res.data?.content
                        }
                    }
                })
                .catch(err => {
                    if (!err) {
                        customToast.error('서버와의 연결이 원할하지 않습니다.');
                        return;
                    }

                    let res = err.response;

                    customToast.error(res?.data?.message);
                })
        },
        updateStockCycleMemo: async ({ params, headers, body }) => {
            return await axios.put(`${MAIN_API_HOST}/analytics/stock-cycle/memo`, body, {
                headers
            })
                .then(res => {
                    if (res.status === 200) {
                        return {
                            res: res,
                            content: res.data?.content
                        }
                    }
                })
                .catch(err => {
                    if (!err) {
                        customToast.error('서버와의 연결이 원할하지 않습니다.');
                        return;
                    }

                    let res = err.response;

                    customToast.error(res?.data?.message);
                })
        },
        searchOrderQty: async ({params, headers, body}) =>{
            return await axios.post(`${MAIN_API_HOST}/analytics/orderQty`, body, {
                headers
            })
        }
    }
}